import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BryntumGridStateService {

  constructor(private http$: HttpClient) { }

  loadGridState(bryntumComponentTypeId: number) {
    return this.http$.get(`/api/bryntum/grid/state/${bryntumComponentTypeId}`);
  }

  saveGridState(bryntumComponentTypeId: number, configuration: any) {
    if (!configuration) {
      configuration = {};
    }
    return this.http$.post(`/api/bryntum/grid/state/${bryntumComponentTypeId}`,
      {
        jsonstring: JSON.stringify({ name: 'test' }),
        gridState: {
          columns: JSON.stringify(configuration.columns),
          rowHeight: JSON.stringify(configuration.rowHeight),
          scroll: JSON.stringify(configuration.scroll),
          selectedRecords: JSON.stringify(configuration.selectedRecords),
          store: JSON.stringify(configuration.store),
          style: JSON.stringify(configuration.style),
          subGrids: JSON.stringify(configuration.subGrids),
        }
      },
      { headers: { 'skip-loading': 'true' } }
    );

  }
}
